import NoData from "assets/svgs/no_data/NoData";
import { isEmpty } from "lodash";
import PaginationDiv from "modules/pagination/PaginationDiv";
import { fourPlaceHolder, getValue } from "modules/utilities/utility";
import React, { useEffect, useMemo, useState } from "react";
import { useToast } from "modules/navbar/top/store/toasterStore";
import CardDiv from "modules/common/card-div/CardDiv";
import { useManageContentStore } from "modules/manage_contents/store";
import { Button, Input, Popconfirm, Select, Tooltip } from "antd";
const { Search } = Input;
import { optionsContent } from "modules/utilities/utility";
import ManageContentModal from "modules/manage_contents/ManageContentModal";
import { DeleteOutlined, FileTextOutlined } from "@ant-design/icons";
import ManageContentLinkModal from "modules/manage_contents/ManageContentLinkModal";
import AddContentModal from "modules/manage_contents/AddContentModal";

function ManageContents() {
  const { contentData, contentLoading, fetchManageContentData, removeContent } =
    useManageContentStore();
  const [page, newPage] = useState(1);
  const { setToaster } = useToast();
  const [searchText, setSearchText] = useState("");
  const [filter, setFilter] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [contentKey, setContentKey] = useState();
  const [modalLinkShow, setModalLinkShow] = useState(false);
  const [linkKey, setLinkKey] = useState();

  useEffect(() => {
    if (searchText) {
      const debounceTimeout = setTimeout(() => {
        const keyword = `&key=${searchText}&`;
        if (searchText && filter) {
          fetchManageContentData(page - 1, filter, keyword);
        } else {
          fetchManageContentData(page - 1, "", keyword);
        }
      }, 700);
      return () => {
        clearTimeout(debounceTimeout);
      };
    }
    if (filter) {
      fetchManageContentData(page - 1, filter, "");
    } else {
      fetchManageContentData(page - 1, "", "");
    }
  }, [page, filter, searchText]);

  const ContData = useMemo(() => {
    if (isEmpty(contentData?.data)) return [];
    return contentData?.data.contents.map((row) => ({
      key: getValue(row, "_id"),
      contentName: getValue(row, "displayName"),
      contentType: getValue(row, "type"),
      url: row.componentAttributes?.contentLink,
    }));
  }, [contentData?.data]);


  const handleSearch = (value) => {
    setSearchText(value);
  };

  const handleEdit = (id) => {
    setModalShow(true);
    setContentKey(id);
  };

  const handleLink=(id)=>{
    setLinkKey(id);
    setModalLinkShow(true);
  }

  const handleDelete = (id) => {
    removeContent(id, setToaster, fetchManageContentData, filter, searchText);
  };

  const header = [
    "Content Name",
    "Content Type",
    "URL / Swirl ID",
    "Link Tags",
    "Actions",
  ];

  return (
    <div>
      <CardDiv
        title={
          <div className="d-flex justify-content-between align-items-center">
            <div className="fs-2">Manage Contents</div>
            <div className="d-flex flex-row gap-4">
              <div>
                <Select
                  allowClear
                  placeholder="content type"
                  value={filter}
                  style={{ width: 130 }}
                  onChange={(role) => {
                    setFilter(role);
                  }}
                  options={optionsContent}
                />
              </div>
              <Search
                allowClear
                placeholder="Search"
                onSearch={handleSearch}
                onChange={({ target }) => handleSearch(target.value)}
                maxLength={80}
              />
              <AddContentModal filter={filter} searchText={searchText} />
            </div>
          </div>
        }
        component={
          <>
            <div>
              <div className="mt-1 shadow rounded mt-2">
                <div className="d-flex table-head rounded-top">
                  {header?.map((item) => {
                    return (
                      <span className="p-3  fw-bold text-black flex-1 border-end">
                        {item}
                      </span>
                    );
                  })}
                </div>
                {contentLoading ? (
                  fourPlaceHolder()
                ) : ContData && ContData?.length ? (
                  ContData?.map((item, index) => {
                    return (
                      <div
                        className={`d-flex table-row border-1 border-top-0 ${
                          index === ContData?.length - 1 && `rounded-bottom`
                        }`}
                      >
                        <span className="p-3 flex-1 fw-bold text-break text-black text-wrap border-end">
                          {item?.contentName}
                        </span>
                        <span className="p-3 flex-1 fw-bold text-break text-black text-wrap border-end">
                          {item?.contentType}
                        </span>
                        <span className="p-3 flex-1 fw-bold text-break text-black text-wrap border-end">
                          {item?.url}
                        </span>
                        <span
                          className="p-3 flex-1 fw-bold text-break  text-primary text-wrap border-end cursor-pointer"
                          onClick={() => handleLink(item?.key)}
                        >
                          Link Tag
                        </span>
                        <span className="p-3 d-flex gap-4 flex-1 text-break text-black text-wrap border-end">
                          <span className="cursor-pointer text-primary fw-bold">
                            <Tooltip title="Edit Content">
                              <Button
                                icon={<FileTextOutlined />}
                                onClick={() => handleEdit(item?.key)}
                                type="link"
                              />
                            </Tooltip>
                          </span>
                          <span className="cursor-pointer fw-bold text-danger">
                            <Popconfirm
                              title={<div>Are you sure to delete </div>}
                              placement="topRight"
                              onConfirm={() => handleDelete(item?.key)}
                            >
                              <Button
                                danger
                                icon={<DeleteOutlined />}
                                type="link"
                              />
                            </Popconfirm>
                          </span>
                        </span>
                      </div>
                    );
                  })
                ) : (
                  <div className="p-3 bg-white rounded-bottom text-center">
                    No Data Available <NoData />
                  </div>
                )}
              </div>
            </div>
            <div>
              <PaginationDiv
                paginationData={{
                  pageCount: contentData?.data?.total
                    ? Math.ceil(contentData?.data?.total / 10)
                    : 1,
                  page: page,
                }}
                newPage={newPage}
              />
            </div>
          </>
        }
      />
      <ManageContentModal
        modalShow={modalShow}
        setModalShow={setModalShow}
        contentKey={contentKey}
        filter={filter}
        searchText={searchText}
      />
      <ManageContentLinkModal
        modalShow={modalLinkShow}
        setModalShow={setModalLinkShow}
        contentKey={linkKey}
      />
    </div>
  );
}

export default ManageContents;
